import ArtworkEditor from "./ArtworkEditor"

export default ArtworkEditor